
<template>
  <div class="process black">
    <div class="layout-content">
      <SubTitle class="title" :text="data.title" subText="FINTECHATHON" />
      <div>
        <img
          v-if="!isMobile"
          class="content-img"
          src="https://static001.geekbang.org/resource/image/85/e3/85bfb72c29a39baf1f34yyddca70e9e3.png"
        >
        <img
          v-else
          class="content-img"
          src="https://static001.geekbang.org/resource/image/82/6c/82fe769cce3b5d55388e533c7fce566c.png"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SubTitle from '@/components/SubTitle'

export default {
  props: ['data'],
  data () {
    return {

    }
  },
  components: {
    SubTitle
  },

  computed: {
    ...mapState([
      'isMobile'
    ])
  }
}
</script>

<style lang="scss" scoped>

.process {
  padding: 80px 0 100px;
  background: url('https://static001.geekbang.org/resource/image/4f/43/4f42500ed8c1d24f205d1bd690a1ac43.png') center / cover no-repeat;

  @include mobile {
    padding: 0;
    background: #F7F8FA;
  }
}

.content-img {
  width: 100%;
  @include mobile {
    width: 100%; height: auto;
  }
}
</style>
